import React from 'react';
import { Check } from 'lucide-react';
export function WhatYouGet() {
  const inclusions = ['Structured step-by-step guide', 'HD video walkthroughs', 'Printable checklists', 'Mixing ratio tables', 'Error diagnostic guide', 'Supplier list', 'Lifetime access'];
  return <section className="py-20 bg-white" data-id="element-149">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-150">
        <div className="bg-[#FDFCF8] border border-stone-100 rounded-3xl p-8 md:p-12 shadow-xl" data-id="element-151">
          <h2 className="text-3xl font-bold text-stone-900 mb-8 text-center" data-id="element-152">
            What’s Included
          </h2>

          <div className="grid md:grid-cols-2 gap-y-4 gap-x-8" data-id="element-153">
            {inclusions.map((item, idx) => <div key={idx} className="flex items-center gap-3 p-3 rounded-lg hover:bg-white transition-colors" data-id="element-154">
                <div className="w-6 h-6 rounded-full bg-teal-100 flex items-center justify-center flex-shrink-0" data-id="element-155">
                  <Check className="w-4 h-4 text-teal-700" data-id="element-156" />
                </div>
                <span className="text-lg text-stone-700 font-medium" data-id="element-157">
                  {item}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}